import React from 'react'
import PropTypes from 'prop-types'
import MiscImage from 'images/misc.svg'
import ProSolidImage from 'images/pro-solid.svg'
import ClaimedIconImage from 'images/claimed-icon.svg'

interface DesignationTooltipProps {
  designation: string
  show?: boolean
  children?: React.ReactElement
}

const DesignationTooltip: React.FC<DesignationTooltipProps> = (props) => {
  let tooltipText: null | string = null
  switch (props.designation) {
    case 'Pro':
      tooltipText = '<b>Pro Profile</b><br>This supplier upgraded to a pro profile, which gives them the ability to provide additional information on their profile to help you make your purchasing decision. Advertising with Procurated does not influence a supplier’s organic search ranking or rating. For more info on this, check out the <a href="https://app.procurated.com/resources/the-procurated-promise">Procurated Promise.</a>'
      break
    case 'MiSC Registered':
      tooltipText = 'This supplier is registered in the Michigan Supplier Community (MiSC) program. Learn more about MiSC <a href="https://www.michigan.gov/dtmb/0,5552,7-358-82550_85746_48677_92322---,00.html" target="_blank">here</a>.'
      break
    case 'MiSC Eligible':
      tooltipText = 'This supplier is eligible, but not yet registered, for the Michigan Supplier Community (MiSC) program. This supplier may be certified by updating their SIGMA VSS profile. Learn more about MiSC <a href="https://www.michigan.gov/dtmb/0,5552,7-358-82550_85746_48677_92322---,00.html" target="_blank">here</a>.'
      break
  }

  if (props.show !== true || tooltipText === null) return <>{props.children}</>

  return (
    <div
      data-tooltip
      data-allow-html
      tabIndex={2}
      title={tooltipText}
    >
      {props.children}
    </div>
  )
}

DesignationTooltip.propTypes = {
  designation: PropTypes.string.isRequired,
  show: PropTypes.bool
}

interface DesignationIconProps {
  designation: string
}

const DesignationIcon: React.FC<DesignationIconProps> = ({ designation }) => {
  if (designation === 'Pro') {
    return <img src={ProSolidImage} alt='Pro' />
  } else if (designation.startsWith('MiSC')) {
    return <img src={MiscImage} alt='MiSC' width='30px' />
  } else if (designation === 'Claimed') {
    return <img src={ClaimedIconImage} alt='Claimed' />
  }

  return <i className='fak fa-stairs-up supplier-designation-icon' />
}

DesignationIcon.propTypes = {
  designation: PropTypes.string.isRequired
}

interface DesignationBadgeProps {
  designation: string
}

const DesignationBadge: React.FC<DesignationBadgeProps> = ({ designation }) => {
  const className = designation === 'Pro' ? 'supplier-pro-designation-badge' : 'supplier-designation-badge'

  return (
    <div className={`${className} body-x-small`}>
      <DesignationIcon designation={designation} />
      <span>{designation.replace('MiSC', '').trim()}</span>
    </div>
  )
}

DesignationBadge.propTypes = {
  designation: PropTypes.string.isRequired
}

export interface SupplierDesignationsProps {
  designations: string[]
  includeTooltips?: boolean
}

const SupplierDesignations: React.FC<SupplierDesignationsProps> = (props) => {
  return (
    <div className='supplier-designations-container'>
      {props.designations.map((designation) => {
        return (
          <DesignationTooltip designation={designation} show={props.includeTooltips} key={designation}>
            <DesignationBadge designation={designation} />
          </DesignationTooltip>
        )
      })}
    </div>
  )
}

SupplierDesignations.propTypes = {
  designations: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  includeTooltips: PropTypes.bool
}

export default SupplierDesignations
